import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { BaseResizableComponent } from '@src/app/modules/base';

import { LoyaltyProgramReadService, LpFavoriteProductsStoreService, ProductsStoreKeys } from '../services';
import { LoyaltyProgramProduct } from '../models';

@Component({
  selector: 'lp-favorite-products',
  templateUrl: './lp-favorite-products.component.html',
  styleUrls: ['./lp-favorite-products.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpFavoriteProductsComponent extends BaseResizableComponent {
  private readonly loyaltyProgramReadService = inject(LoyaltyProgramReadService);
  private readonly lpFavoriteProductsStore = inject(LpFavoriteProductsStoreService);

  products?: LoyaltyProgramProduct[];
  loading = true;

  override ngOnInit(): void {
    super.ngOnInit();

    this.loyaltyProgramReadService.getFavoriteProducts();

    this.lpFavoriteProductsStore
      .getDataObservable(ProductsStoreKeys.Favorite)
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(storeProducts => {
        this.loading = !storeProducts;
        this.products = storeProducts;

        this.cdr.markForCheck();
      });
  }
}
